export default __webpack_public_path__ + "static/media/acorn-25.4fbf1f5f.png";